import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=3d0ad35a&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=ts"
export * from "./Switcher.vue?vue&type=script&lang=ts"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=3d0ad35a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ad35a",
  null
  
)

export default component.exports